import { IncomingMessage } from 'http';
import nookies from 'nookies';

import { ComplianceLevel } from '@/store/complianceLevel/types';
import { determineComplianceLevelFromCookies } from '@/utils/getInitialState/initComplianceLevel';

export const determineComplianceLevelMiddleware = (
	req: IncomingMessage,
	requiresGdpr: boolean | null,
): ComplianceLevel => {
	const cookies = nookies.get({ req });
	return determineComplianceLevelFromCookies(cookies, requiresGdpr);
};
